import useAccountPageParams from "../../../../hooks/useAccountPageParams";
import { useAccount } from "../../../../hooks/QueryHooks";
import useWorkspaceStore from "../../../../store/workspace/workspaceStore";
import SignalDocumentsPanel from "../../signals/signal-documents/SignalDocumentsPanel";

const AccountDocuments = () => {
  const { accountId }: any = useAccountPageParams();
  const currentWorkspace = useWorkspaceStore((state) => state.workspace);

  const account: any = useAccount({
    accountId: accountId || "",
    workspaceId: currentWorkspace?.id,
    enabled: accountId !== "" && !!currentWorkspace?.id,
  });

  if (!account?.data?.external_id) return null;

  return (
    <SignalDocumentsPanel
      entityId={account.data.external_id}
      workspaceId={currentWorkspace?.id}
    />
  );
};

export default AccountDocuments;
